export const inverterPower = (totalLoadsPower) => {
  const SECURITY_FACTOR = 0.75;
  const inverterPowerValue = totalLoadsPower / SECURITY_FACTOR;
  return Math.round(inverterPowerValue);

  // This function will be called by phasesCalculator.js
};
